import { createSlice } from '@reduxjs/toolkit'

export const globalSlice = createSlice({
  name: 'global',
  initialState: {
    lang: 'en',
  },
  reducers: {
    setLangAction: (state, action) => {
      state.lang = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setLangAction } = globalSlice.actions

export default globalSlice.reducer